import FinancialsWidgetChart from 'react/components/dashboard/financials_widget_charts';

angular.module('gym.components').value('FinancialsWidgetChart', FinancialsWidgetChart);
